<template>
  <div id="billingContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_billing.webp" class="icon-pages" alt="" />
        <span class="page-title">{{ $t("page.billing") }}</span>
        <div class="page-des-line">
          <span class="page-des ml-10">{{
            $t("page.billing_description")
          }}</span>
        </div>
      </div>

      <div class="div-page-content mt-32" style="padding: 56px 46px">
        <div class="flex-row-center">
          <div class="fs-18 fw-700 flex-center">
            {{ $t("billing.BILLING_SUMMARY") }}
          </div>
          <div style="
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: flex-end;
            ">
            <div style="width: 220px">
              <el-menu class="input-select" mode="horizontal">
                <el-submenu index="0" style="width: 220px">
                  <template slot="title">
                    <span class="text-dropdown" id="userStatus">{{
                      selectMonthOfYear.label
                    }}</span>
                  </template>
                  <div class="scroll-style thin-scrollbar">
                    <el-menu-item v-for="data in MonthOfYearOpt" :key="data.value" @click="monthBilling(data)"
                      class="is-active" style="font-size: 14px; width: 220px">
                      {{ data.label }}
                    </el-menu-item>
                  </div>
                </el-submenu>
              </el-menu>
            </div>
            <div @click="exportHtml" class="btn-6C30CC btn btn-export ml-16">
              Export
            </div>
          </div>


        </div>
        <div class="total-border">
          <div class="total-card grid-2-total" v-for="(item) in billingSummary" :key="item.currency">
            <div class="grid-sub-total-3">
              <div class="total-summary" v-if="item.subscription !== undefined">
                <div class="fs-13 fw-700">{{ $t("billing.SUBSCRIPTION") }}</div>
                <div class="fs-21">
                  {{ allSymbol[item.currency] + addCommasInNumber(item.subscription) }}
                </div>
              </div>
              <div class="total-summary" v-else>
              </div>
              <div class="total-summary">
                <div class="fs-13 fw-700">
                  {{ $t("billing.REWARDS_CHARGES") }}
                </div>
                <div class="fs-21">
                  {{ allSymbol[item.currency] + addCommasInNumber(item.reward_charges) }}
                </div>
              </div>
              <div class="total-summary">
                <div class="fs-13 fw-700">
                  TOP-UP CREDITS
                </div>
                <div class="fs-21">
                  {{ allSymbol[item.currency] + addCommasInNumber(item.topupCredit) }}
                </div>
              </div>
            </div>
            <div class="bg-F8F4FC grid-sub-total">
              <div class="total-summary">
                <div class="fs-13 fw-700">
                  {{ $t("billing.REWARD_CREDIT_BALANCE") }}
                </div>
                <div class="fs-21">
                  {{ allSymbol[item.currency] + addCommasInNumber(item.reward_credit_balance) }}
                </div>
              </div>
              <div class="total-summary">
                <div class="fs-13 fw-700">
                  {{ $t("billing.REWARDS_PENDING") }}
                </div>
                <div class="fs-21">
                  {{ allSymbol[item.currency] }}{{ (billingPending[item.currency] &&
                    billingPending[item.currency].reward_pending)
                    ? addCommasInNumber(billingPending[item.currency].reward_pending) : '0.00' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-20">
          <el-table :data="billingData" style="width: 100%" class="fc-000000" empty-text=" ">
            <el-table-column prop="data" :label="$t('billing.Date')" width="175">
              <template slot-scope="scope">
                <div class="opa-08">{{ scope.row.table_date }}</div>
                <div>&nbsp;</div>
              </template>
            </el-table-column>
            <el-table-column prop="data" :label="$t('billing.Category')" width="120">
              <template slot-scope="scope">
                <div class="opa-08">{{ scope.row.table_category }}</div>
                <div>&nbsp;</div>
              </template>
            </el-table-column>
            <el-table-column prop="data" :label="$t('billing.Description')" width="335">
              <template slot-scope="scope">
                <div v-if="scope.row.table_category == 'Subscription'">
                  <div>
                    <span class="opa-08">{{
                      scope.row.table_description
                    }}</span>
                  </div>
                  <div>
                    <span @click.prevent="showActiveUser(scope.row)" class="fc-32C2D5 cursor-pointer italic underline">
                      {{ scope.row.active_users }}
                      {{ $t("billing.active_members") }}
                    </span>&nbsp;
                    <span v-if="scope.row.show_minimum">
                      {{ `(` + scope.row.minimum_users }}
                      {{ $t("billing.seats_charged") + `)` }}
                    </span>
                  </div>
                </div>
                <div v-else-if="
                  scope.row.table_category == 'Rewards' &&
                  scope.row.table_description == 'Top-up Credits'
                ">
                  <div class="opa-08">{{ scope.row.table_description }}</div>
                  <div class="opa-05 italic">
                    {{ $t("billing.credit_balance") }}:
                    {{
                      scope.row.balance
                        ? allSymbol[scope.row.credit_currency] + addCommasInNumber(scope.row.balance)
                        : "-"
                    }}
                  </div>
                </div>
                <div v-else-if="scope.row.table_category == 'Rewards'">
                  <div class="opa-08">{{ scope.row.table_description }}</div>
                  <div class="opa-05 italic">
                    <!-- {{ $t('billing.credit_remaining') }}: {{ (scope.row.instant_reward_price) ? symbol+addCommasInNumber(scope.row.instant_reward_price) : '-' }} -->
                    {{ scope.row.detail_txt ? scope.row.detail_txt : "-" }}
                  </div>
                </div>
                <div v-else>
                  <div class="opa-08">{{ scope.row.table_description }}</div>
                  <div>&nbsp;</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="data" :label="$t('billing.Amount')" width="135" align="right">
              <template slot-scope="scope">
                <div class="fw-700" v-if="
                  scope.row.table_category == 'Rewards' &&
                  scope.row.table_description == 'Top-up Credits'
                ">
                  {{
                    scope.row.total
                      ? ((scope.row.symbol) ? scope.row.symbol : allSymbol[scope.row.credit_currency]) +
                      addCommasInNumber(scope.row.total)
                      : "-"
                  }}
                </div>
                <div v-else class="fw-700">
                  {{
                    scope.row.total
                      ? ((scope.row.symbol) ? scope.row.symbol : allSymbol[companySymbol]) +
                      addCommasInNumber(scope.row.total)
                      : "-"
                  }}
                </div>
                <div>&nbsp;</div>
              </template>
            </el-table-column>
            <el-table-column width="10">
              <div>&nbsp;</div>
            </el-table-column>
            <el-table-column prop="data" :label="$t('billing.Status')" width="110">
              <template slot-scope="scope">
                <span class="span-status-tag" :class="`tag-${scope.row.table_status}`">{{ (scope.row.table_status ==
                  'bill-sent') ? 'Bill Sent' : scope.row.table_status }}</span>
                <div>&nbsp;</div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="data" width="90" align="center" class="test">
              <template slot-scope="scope">
                <div style="position: absolute; top: 4px">
                  <el-button
                    @click.prevent="viewBilling(scope.row.table_description)"
                  >
                    {{ $t("global.view") }}
                  </el-button>
                </div>
              </template>
            </el-table-column> -->
          </el-table>
          <div v-if="loadingDatableTable" class="center mt-10 mb-40 pt-10 pb-40 relative"
            style="margin-top: -60px; z-index: 99">
            <div v-for="value in [1, 2, 3, 4]" :key="'custom_mock_question_' + value" :class="{
              'opa-02': value == 4,
              'opa-04': value == 3,
              'opa-06': value == 2,
            }" class="flex" style="height: 70px">
              <div class="" style="width: 175px">
                <div class="text-skeleton fs-18" style="width: 100px">
                  &nbsp;
                </div>
              </div>
              <div class="" style="width: 120px">
                <div class="text-skeleton fs-18 ml-12" style="width: 70px">
                  &nbsp;
                </div>
              </div>
              <div class="" style="width: 335px">
                <div class="text-skeleton fs-16 ml-12" style="width: 200px">
                  &nbsp;
                </div>
                <div class="text-skeleton fs-18 opa-04 mt-8 ml-12" style="width: 80px">
                  &nbsp;
                </div>
              </div>
              <div class="" style="width: 145px">
                <div class="text-skeleton fs-18 ml-auto mr-20" style="width: 80px">
                  &nbsp;
                </div>
              </div>
              <div class="" style="width: 100px">
                <div class="text-skeleton fs-18 ml-6" style="width: 60px">
                  &nbsp;
                </div>
              </div>
              <!-- <div class="opa-02" style="width: 90px">
              <el-button class="btnActionView btn-gray-outline" style="margin-top: -24px">
                <div class="fs-15" style="width: 32px">&nbsp;</div>
              </el-button>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogActiveMembers" width="680px" top="8vh">
      <div v-if="countryInCompany.length == 1">
        <div class="recipients-modal recipients-header">
          <div class="">
            <span class="fs-20 fw-700 fc-000000">{{ modal_monthofyear }}</span>

          </div>
          <div class="mt-24 d-flex justify-content-between align-items-center">
            <span class="fs-18 fw-700 fc-000000">{{ $utils("addCommasInNumber", modal_active) }}
              {{ $t("billing.active_members") }}</span>
            <div class="copy-btn" @click="copyTableData">
              <i class="el-icon-document-copy mr-2"></i>Copy
            </div>
          </div>
        </div>
        <div class="members-recipients thin-scrollbar pl-12 mr-6">
          <user-active-table :tableData="activeMember"></user-active-table>
        </div>
      </div>
      <div v-else>
        <div class="recipients-header">
          <span class="fs-20 fw-700 fc-000000 pl-40">{{
            modal_monthofyear
          }}</span>
          <el-tabs class="tab-style" v-model="activeModlaTab">
            <el-tab-pane name="all" key="all" default>
              <div slot="label" class="title-label">
                All ({{ $utils("addCommasInNumber", modal_active) }})
              </div>
              <div class="ml-40 members-recipients thin-scrollbar mr-16"
              :class="[ blurMode ?  'blurelement': '' ]">
                <user-active-table :tableData="activeMember"></user-active-table>
              </div>
            </el-tab-pane>
            <el-tab-pane v-for="item in countryInCompany" :label="item.id" :key="item.id" :name="item.id">
              <div slot="label" class="title-label">
                {{ item.country }} ({{
                  $utils("addCommasInNumber", countryMember[item.id] ? countryMember[item.id].length : 0)
                }})
              </div>
              <div class="ml-40 members-recipients thin-scrollbar mr-16"
              :class="[ blurMode ?  'blurelement': '' ]">
                <user-active-table :tableData="countryMember[item.id]"></user-active-table>
              </div>
            </el-tab-pane>

            <!-- <el-tab-pane name="Thailand" default>
              <div slot="label" class="title-label">
                Thailand ({{ $utils("addCommasInNumber", modal_active) }})
              </div>
              <div class="ml-40 members-recipients thin-scrollbar mr-16">
                <user-active-table
                  :tableData="activeMember"
                ></user-active-table>
              </div>
            </el-tab-pane>
            <el-tab-pane name="Malaysia" default>
              <div slot="label" class="title-label">
                Malaysia ({{ $utils("addCommasInNumber", modal_active) }})
              </div>
              <div class="ml-40 members-recipients thin-scrollbar mr-16">
                <user-active-table
                  :tableData="activeMember"
                ></user-active-table>
              </div>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "billing",
  components: {
    loadingEven: require("./even/loading").default,
    userActiveTable: require("./even/table/user-active").default,
  },
  data() {
    return {
      dialogActiveMembers: false,
      modal_monthofyear: "",
      modal_active: "",
      activeModlaTab: "all",
    };
  },
  created() {
    this.$store.dispatch("billing/getMasterRewards", this.user);
    this.$store.dispatch("billing/getMonthOfYearOpt", this.user);
    this.$store.dispatch("billing/getBillingData", this.user);
    this.$store.commit("authen/setActiveIndex", "2");
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    billingData() {
      return this.$store.getters["billing/billingData"];
    },
    activeMember() {
      return this.$store.getters["billing/activeMember"];
    },
    subscription() {
      return this.$store.getters["billing/subscription"];
    },
    reward_charges() {
      return this.$store.getters["billing/reward_charges"];
    },
    topupCredit() {
      return this.$store.getters["billing/topupCredit"];
    },
    reward_credit_balance() {
      return this.$store.getters["billing/reward_credit_balance"];
    },
    reward_pending() {
      return this.$store.getters["billing/reward_pending"];
    },
    MonthOfYearOpt() {
      return this.$store.getters["billing/MonthOfYearOpt"];
    },
    selectMonthOfYear() {
      return this.$store.getters["billing/selectMonthOfYear"];
    },
    loadingDatableTable() {
      return this.$store.getters["billing/loadingDatableTable"];
    },
    companySymbol() {
      return this.$store.getters["billing/companySymbol"];
    },
    allSymbol() {
      return this.$store.getters["billing/allSymbol"];
    },
    countryInCompany() {
      return this.$store.getters["billing/countryInCompany"];
    },
    countryMember() {
      return this.$store.getters["billing/countryMember"];
    },
    billingSummary() {
      return this.$store.getters["billing/billingSummary"];
    },
    billingPending() {
      return this.$store.getters["billing/billingPending"];
    },
    htmlExport() {
      return this.$store.getters["billing/htmlExport"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  methods: {
    monthBilling(month) {
      this.$store.commit("billing/setSelectMonthOfYear", month);
      this.$store.dispatch("billing/getBillingData", this.user);
    },
    addCommasInNumber(value) {
      let num = Number(value).toFixed(2);
      let str = num.toString().split(".");
      if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      }
      return `${str[0]}.${str[1]}`;
    },
    viewBilling(value) {
      console.log("View :" + value); // TODO: Showing bill on this month
    },
    showActiveUser(item) {
      // Parse the date string to get just "Month YYYY"
      const date = new Date(item.table_date);
      this.modal_monthofyear = format(date, "MMMM YYYY");
      this.modal_active = item.active_users;
      this.dialogActiveMembers = true;
    },
    exportHtml() {
      if (!this.loadingDatableTable) {
        // Create New Tab
        const newTab = window.open('', '_blank');

        // Write HTML to new tab
        newTab.document.write(`${this.htmlExport}`);

        // close the tag document
        newTab.document.close();
      }
    },
    copyTableData() {
      if (!this.activeMember || !this.activeMember.length) {
        this.$message({
          message: 'No data to copy',
          type: 'warning',
          duration: 2000
        });
        return;
      }

      // Update headers to include separate date and time columns
      const headers = ['First Name', 'Last Name', 'Email Address', 'Team Name', 'Last Active Date', 'Last Active Time'];
      const rows = this.activeMember.map(member => {
        const firstName = member.firstname || member.first_name || '';
        const lastName = member.lastname || member.last_name || '';
        const lastDate = member.lastDate || member.lastdate || member.last_date || '';
        const lastTime = member.time || '';
        
        return [
          firstName,
          lastName,
          member.email || '',
          member.team_name || '',
          lastDate,
          lastTime
        ].join('\t');
      });
      
      const textToCopy = [
        `${this.modal_monthofyear}`,
        `${this.modal_active} active members`,
        '',
        headers.join('\t'),
        ...rows
      ].join('\n');

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            this.$message({
              message: 'Copied to clipboard!',
              type: 'success',
              duration: 2000
            });
          })
          .catch(err => {
            console.error('Clipboard API error:', err);
            this.fallbackCopyToClipboard(textToCopy);
          });
      } else {
        this.fallbackCopyToClipboard(textToCopy);
      }
    },

    fallbackCopyToClipboard(text) {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';  // Avoid scrolling to bottom
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        this.$message({
          message: 'Copied to clipboard!',
          type: 'success',
          duration: 2000
        });
      } catch (err) {
        console.error('Fallback clipboard error:', err);
        this.$message({
          message: 'Failed to copy to clipboard',
          type: 'error',
          duration: 2000
        });
      }
    }
  },
};
</script>

<style scoped lang="scss">
.bg-F8F4FC {
  background-color: #f8f4fc;
}

.total-card {
  // padding: 20px 0;
  padding: 20px 0 0 0
}

.grid-2-total {
  // border-top: 1px solid #e0e0e0;
  // margin-top: 40px;
  display: grid;
  grid-template-columns: 56% 44%;
}

.total-border {
  border-top: 1px solid #e0e0e0;
  margin-top: 40px;
}

.grid-sub-total-3 {
  display: grid;
  padding: 24px 0;
  grid-template-columns: 33% 33% 33%;
}

.grid-sub-total {
  display: grid;
  padding: 24px 32px;
  grid-template-columns: 58% 42%;
}

.total-summary {
  padding: 0;
}

.members-recipients {
  flex: 1;
  overflow: auto;
  max-height: 60vh;
}

.recipients-modal {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;
  padding-left: 40px;
  padding-bottom: 16px;
}

.recipients-header {
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  opacity: 1;
}

.tab-style {
  background: #ffffff;
  margin-top: 10px;

  .title-label {
    min-width: 140px;
    text-align: center;
    height: 44px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(#000, 0.8);
  }
}

.scroll-style {
  max-height: 58vh;
  padding-bottom: 1px;
}

.btn-export {
  width: 100px;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 700;
}

.copy-btn {
  margin-right: 24px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #CCC;
  padding: 8px 16px;
  border-radius: 4px;
  &:hover {
    opacity: 0.8;
  }
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.mr-2 {
  margin-right: 4px;
}
</style>

<style lang="scss">
#billingContainer {
  .el-tabs__item {
    height: 44px;
  }

  .el-tabs__item.is-active>.title-label {
    color: #000;
    font-weight: 900;
    font-size: 14px;
  }

  .el-tabs__header {
    margin: 0;
  }
}
</style>